import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getRecords, saveRecords } from "../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import useCreateForm from "../../custom/Utils/UseCreateFormUtils.js";
import { createPageData, basicFormData } from "./JobCardFile.js";
import { validate } from "../../custom/validations/Validate.js";
import {
  formContentContainer,
  loaderOverlay,
} from "../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../Loader/Loader.js";
import formatDateTime from "../../custom/Utils/formatDateTime.js";
import JobCardCreate from "./JobCardCreate.js";
import { loadLanguages } from "i18next";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import { toast } from "react-toastify";

const TechnicianRepair = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    getEndpoint,
    createEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [fetchedData, setFetchedData] = useState(null);
  const [action, setAction] = useState("Mark Repair Completed");
  const [formErrors, setFormErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [repairRemark, setRepairRemark] = useState("");
  const [repairError, setRepairError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const getOnlyDate = (date) => {
    const receivedDate = new Date(date).toLocaleDateString();
    const [month, day, year] = receivedDate?.split("/");
    const formatted = `${day}-${month}-${year}`;
    return formatted;
  };

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const handleValidation = () => {
    if (!repairRemark.trim()) {
      setRepairError("Repair remark cannot be blank");
      return;
    }
    setPopup(true);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        id: id,
        inputData: {
          is_completed: true,
          repair_check_remark: repairRemark,
          updated_by: userDetails?.id,
        },
      };
      // console.log(payload);
      // return;
      const responseData = await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`,
        );
        setPopup(false);
        if (action === "Mark Repair Completed") {
          navigate(navigatePage?.back);
        } else {
          navigate("/scrap-list");
        }
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };
  const filteredSpareItems = useMemo(() => {
    return (
      formData?.inputData?.spare_items?.filter((item) =>
        (item?.material?.gmds_code || item?.material?.name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()),
      ) || []
    );
  }, [formData?.inputData?.spare_items, searchTerm]);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Job Card Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >
                              <p>
                                <strong>Job Card No: </strong>
                                {formData?.inputData?.job_card_no || "-"}
                              </p>

                              <p>
                                <strong>Intake No: </strong>
                                {formData?.inputData?.intake?.intake_no || "-"}
                              </p>
                              <p>
                                <strong>GMDS Code: </strong>
                                {formData?.inputData?.intake?.material
                                  ?.gmds_code ||
                                  formData?.inputData?.intake?.material
                                    ?.name ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Items Matching Invoice: </strong>
                                {formData?.inputData?.intake
                                  ?.items_matching_invoice == null
                                  ? "-"
                                  : formData?.inputData?.intake
                                        ?.items_matching_invoice
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>

                              <p>
                                <strong>Anti Static Bag: </strong>
                                {formData?.inputData?.intake?.anti_static_bag ==
                                null
                                  ? "-"
                                  : formData?.inputData?.intake?.anti_static_bag
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>
                              <p>
                                <strong>Fault Tag Attached: </strong>
                                {formData?.inputData?.intake
                                  ?.fault_tag_attached == null
                                  ? "-"
                                  : formData?.inputData?.intake
                                        ?.fault_tag_attached
                                    ? "Yes"
                                    : "No"}{" "}
                              </p>

                              <p>
                                <strong>Rate Per Unit: </strong>
                                {formData?.inputData?.intake?.rate_per_unit ||
                                  "-"}
                              </p>
                              <p>
                                <strong>Fault Reported From Field: </strong>
                                {formData?.inputData?.intake
                                  ?.fault_reported_from_field || "-"}
                              </p>
                              <p>
                                <strong>Status (Item Intake): </strong>
                                {formData?.inputData?.intake?.status || "-"}
                              </p>
                              <p>
                                <strong>Engineer: </strong>
                                {formData?.inputData?.technician?.full_name ||
                                  "-"}{" "}
                              </p>

                              <p>
                                <strong>Assigned By: </strong>
                                {formData?.inputData?.assigned_by_user
                                  ?.first_name || "-"}{" "}
                                {formData?.inputData?.assigned_by_user
                                  ?.last_name || "-"}
                              </p>
                              <p>
                                <strong>Job Card Status: </strong>
                                {formData?.inputData?.status || "-"}
                              </p>

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                            </Col>

                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>
                                    Engineer Check Is Repairable:{" "}
                                  </strong>
                                  {formData?.inputData
                                    ?.technician_check_is_repairable == null
                                    ? "-"
                                    : formData?.inputData
                                          ?.technician_check_is_repairable
                                      ? "Yes"
                                      : "No"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Engineer Check At: </strong>
                                  {formData?.inputData?.technician_check_at ===
                                  null
                                    ? "-"
                                    : getOnlyDate(
                                        formData?.inputData
                                          ?.technician_check_at,
                                      )}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>
                                    {" "}
                                    {formData?.inputData?.fault_reasons
                                      ?.length > 1
                                      ? "Fault Reasons: "
                                      : "Fault Reason: "}{" "}
                                  </strong>
                                  {formData?.inputData?.fault_reasons?.length
                                    ? formData.inputData.fault_reasons
                                        .map((item) => item.reason)
                                        .join(", ")
                                    : "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Component Reference No. 1: </strong>
                                  {formData?.inputData
                                    ?.component_reference_no_1 || "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Component Reference No. 2: </strong>
                                  {formData?.inputData
                                    ?.component_reference_no_2 || "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Component Reference No. 3: </strong>
                                  {formData?.inputData
                                    ?.component_reference_no_3 || "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Component Reference No. 4: </strong>
                                  {formData?.inputData
                                    ?.component_reference_no_4 || "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Component Reference No. 5: </strong>
                                  {formData?.inputData
                                    ?.component_reference_no_5 || "-"}
                                </p>
                              )}
                              {(formData?.inputData
                                ?.technician_check_is_repairable === true ||
                                formData?.inputData
                                  ?.technician_check_is_repairable ===
                                  false) && (
                                <p>
                                  <strong>Engineer Check Remark: </strong>
                                  {formData?.inputData
                                    ?.technician_check_remark || "-"}
                                </p>
                              )}

                              <p>
                                <strong>Created At: </strong>
                                {!formData?.inputData?.createdAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.createdAt,
                                    )}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {!formData?.inputData?.updatedAt || loadingData
                                  ? "-"
                                  : formatDateTime(
                                      formData?.inputData?.updatedAt,
                                    )}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {formData?.inputData?.status != "Pending" && (
            <div className="card p-3">
              <Row className="">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="h-6-heading">Item Details</h6>
                  <div className="app-search d-flex d-lg-inline mt-0 p-0">
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control ps-5"
                        placeholder="Search by item name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                          width: "13rem",
                          padding: "8px 15px",
                          borderRadius: "8px",
                          borderColor: "#D2D2D2",
                          outline: "none",
                          transition: "all 0.3s ease",
                          boxShadow: "none",
                          marginRight: "0.5rem",
                        }}
                      />
                      <span className="ri-search-line"></span>
                    </div>
                  </div>
                </div>
                <div
                  className="table mt-2"
                  style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    width: "100%",
                    scrollBehavior: "smooth",
                  }}
                >
                  <table className="table table-hover">
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f9992d",
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        <th>Sr. No</th>
                        <th>GMDS Code</th>
                        <th>Available Quantity</th>
                        <th>Require Quantity</th>
                        <th>Remark</th>
                      </tr>
                    </thead>

                    <tbody>
                      {filteredSpareItems.length > 0 ? (
                        filteredSpareItems.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>

                            <td>{item?.material?.gmds_code || item?.material?.name}</td>

                            <td>{item?.available_qty}</td>

                            <td>{item?.required_qty}</td>
                            <td>{item?.remark}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No data found...
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Row>
            </div>
          )}
          <div className="card">
            <form className="card-body">
              <Row className="mt-1">
                <>
                  <Col md="6" className="mt-3">
                    <TextAreaInput
                      label="Repair Remark"
                      name="repairRemark"
                      value={repairRemark}
                      onChange={(e) => {
                        setRepairRemark(e.target.value);
                        setRepairError("");
                      }}
                      placeholder="Repair Remark"
                      inputClassName="form-control"
                      labelClassName="form-label"
                      asterisk={true}
                      customError={repairError}
                    />
                  </Col>
                </>
              </Row>
              <div className="mt-3 d-flex gap-3 flex-wrap">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleValidation}
                >
                  {action}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setAction("None");
                    navigate(navigatePage?.back);
                  }}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </form>
            <BasicPopupModel
              isVisible={popup}
              onClose={() => setPopup(false)}
              title={`Are you sure you want to ${action} this job card?`}
            >
              <div className="mt-3">
                <div className="mt-3 d-flex gap-3 flex-wrap justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e) => {
                      handleSubmit(e);
                      setPopup(false);
                    }}
                  >
                    {action}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setPopup(false);
                    }}
                    className="btn btn-secondary"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </BasicPopupModel>
          </div>

          {/* Loader Overlay */}
          {loadingData && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TechnicianRepair;
